export default __webpack_public_path__ + "static/cafe_36067-7cbc94fb190187af7361c7ecf94a4b54.png";